import {
    Button,
    Col,
    DatePicker,
    Form,
    Input,
    Row,
    Select,
    Typography,
    TimePicker,
    Upload
} from "antd";

import { UploadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { addSingleProject } from "../../redux/rtk/features/projectManagement/project/project/project";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import PageTitle from "../page-header/PageHeader";

const AddProject = ({ drawer }) => {
    const [loader, setLoader] = useState(false);
    const [hourlyRate, setHourlyRate] = useState(null);
    const [selectedServiceMan, setSelectedServiceMan] = useState(null);
    const userList = useSelector((state) => state.users.list);

    const dispatch = useDispatch();
    const [form] = Form.useForm();

    useEffect(() => {
        dispatch(loadAllStaff({ status: "true" }));
    }, []);

const onFinish = async (values) => {
    try {
        setLoader(true);

        const formData = new FormData();

        if (values.image && values.image[0]?.originFileObj) {
            formData.append("image", values.image[0].originFileObj);
        }

        formData.append("projectManagerId", values.projectManagerId);
        formData.append("requesterId", values.requesterId);
        formData.append("name", values.name?.trim());
        formData.append("description", values.description?.trim());
        formData.append("location", values.location?.trim());
        formData.append("startDate", dayjs(values.startDate).toISOString());
        formData.append("startTime", values.startTime?.format("HH:mm") || "");

        const offerValueNum = values.offerValue
            ? parseFloat(values.offerValue)
            : parseFloat(hourlyRate);

        const isCustomOffer = values.offerValue && offerValueNum > 0;

        formData.append("isCustomOffer", isCustomOffer ? "true" : "false");
        formData.append("offerValue", offerValueNum || 0);

        const resp = await dispatch(addSingleProject(formData));

        if (resp.payload.message === "success") {
            form.resetFields();
        }
    } catch (error) {
        toast.error("Something went wrong during bokking submission.");
        console.error("Booking creation error:", error.message);
    } finally {
        setLoader(false);
    }
};



    const onFinishFailed = () => {
        toast.warning("Failed at adding Booking");
        setLoader(false);
    };

    const { Title } = Typography;

    return (
        <Fragment>
            <PageTitle title={"Back"} />
            <Row className="mr-top" justify="center">
                <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={drawer ? 22 : 18}
                    xl={drawer ? 22 : 16}
                    className="column-design border rounded card-custom"
                >
                    <Title level={4} className="m-2 mt-5 mb-5 text-center">
                        Create Booking
                    </Title>
                    <Form
                        form={form}
                        name="add-project-form"
                        labelCol={{ span: 7 }}
                        wrapperCol={{ span: 12 }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        style={{ marginBottom: "40px" }}
                    >
                        {/* Project Manager */}
                        <Form.Item
                            label="Service Man"
                            name="projectManagerId"
                            rules={[{ required: true, message: "Select Service Man" }]}
                        >
                            <Select
                                loading={!userList.length}
                                showSearch
                                placeholder="Select Service Man"
                                optionFilterProp="children"
                                onChange={(value) => {
                                    const selected = userList.find(user => user.id === value);
                                    setSelectedServiceMan(selected || null);
                                    setHourlyRate(selected?.hourlyRate || null);
                                    if (!selected) {
                                        form.setFieldsValue({ offeredHourlyRate: null });
                                    }
                                }}
                            >
                                {userList.filter(item => item.roleId === 3).map(item => (
                                    <Select.Option key={item.id} value={item.id}>
                                        {item.firstName} {item.lastName}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        {/* Hourly Rate */}
                        {hourlyRate !== null && (
                            <Form.Item label="Hourly Rate">
                                <Input value={`€${hourlyRate}`} readOnly />
                            </Form.Item>
                        )}

                        {/* Offered Hourly Rate */}
                        {selectedServiceMan && (
                            <Form.Item label="Offered Hourly Rate" name="offerValue">
                                <Input placeholder="Enter Offered Hourly Rate" />
                            </Form.Item>
                        )}

                        {/* Requester */}
                        <Form.Item
                            label="Customer"
                            name="requesterId"
                            rules={[{ required: true, message: "Select Customer" }]}
                        >
                            <Select
                                loading={!userList.length}
                                showSearch
                                placeholder="Select Customer"
                                optionFilterProp="children"
                            >
                                {userList.filter(item => item.roleId === 2).map(item => (
                                    <Select.Option key={item.id} value={item.id}>
                                        {item.firstName} {item.lastName}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        {/* Task Name */}
                        <Form.Item
                            label="Task Name"
                            name="name"
                            rules={[{ required: true, message: "Enter Task Name" }]}
                        >
                            <Input placeholder="Enter Task Name" />
                        </Form.Item>

                        {/* Start Date */}
                        <Form.Item
                            label="Start Date"
                            name="startDate"
                            rules={[{ required: true, message: "Select Start Date" }]}
                        >
                            <DatePicker
    disabledDate={(current) => {
      return current && current < dayjs().startOf("day");
    }}
  />
                        </Form.Item>

                        {/* Start Time */}
                        <Form.Item
                            label="Start Time"
                            name="startTime"
                            rules={[{ required: true, message: "Select Start Time" }]}
                        >
                            <TimePicker format="HH:mm" />
                        </Form.Item>

                        {/* Description */}
                        <Form.Item
                            label="Task Description"
                            name="description"
                            rules={[{ required: true, message: "Enter Task Description" }]}
                        >
                            <Input.TextArea placeholder="Enter Task Description" />
                        </Form.Item>

                         <Form.Item
                            label="Location"
                            name="location"
                            rules={[{ required: true, message: "Enter Location" }]}
                        >
                            <Input placeholder="Enter Location" />
                        </Form.Item>

                        {/* Upload Image */}
                        <Form.Item
                            label="Upload Image"
                            name="image"
                            valuePropName="fileList"
                            getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
                            rules={[{ required: false }]}
                        >
                            <Upload
                                listType="picture"
                                maxCount={1}
                                beforeUpload={() => false} // prevent auto upload
                            >
                                <Button icon={<UploadOutlined />}>Select Image</Button>
                            </Upload>
                        </Form.Item>

                        {/* Submit Button */}
                        <Form.Item wrapperCol={{ offset: 7, span: 12 }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                block
                                size="large"
                                loading={loader}
                            >
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </Fragment>
    );
};

export default AddProject;
